import { render } from "./OrderRecap.vue?vue&type=template&id=21cfde89"
import script from "./OrderRecap.vue?vue&type=script&lang=js"
export * from "./OrderRecap.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__